import { request } from "@umijs/max";
/** Login With Captcha 账号密码登录（带验证码） POST /api/admin/v1/login */


const token = localStorage.getItem('token');
    const headers: Record<string, string> = {};
    if (token) {
        headers.Authorization = `Bearer ${token}`;
    }
export async function CurrentUser(
    body: API.LoginWithCaptcha,
    options?: { [key: string]: any }
) {
    return request<any>("/api/admin/v1/login", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        data: body,
        ...(options || {}),
    });
}


export async function queryCurrentUser(options?: { [key: string]: any }) {
    return request<any>("/api/admin/v1/current_user", {
        method: "GET",
        headers,
        ...(options || {}),
    });
}

export async function outLogin(options?: { [key: string]: any }) {
    
    return request<any>("/api/admin/v1/login/outLogin", {
        method: "POST",
        headers,
        ...(options || {}),
    });
}

export async function rule(params?: { [key: string]: any }, options?: { [key: string]: any }) {
    return request<any>("/api/rule", {
        method: "GET",
        params: { ...params },
        ...(options || {}),
    });
}

export async function addRule(params?: { [key: string]: any }, options?: { [key: string]: any }) {
    return request<any>("/api/rule", {
        method: "POST",
        data: { ...params },
        ...(options || {}),
    });
}

export async function updateRule(params?: { [key: string]: any }, options?: { [key: string]: any }) {
    return request<any>("/api/rule", {
        method: "PUT",
        data: { ...params },
        ...(options || {}),
    });
}

export async function removeRule(params?: { [key: string]: any }, options?: { [key: string]: any }) {
    return request<any>("/api/rule", {
        method: "DELETE",
        params: { ...params },
        ...(options || {}),
    });
}

